import { type } from 'arktype';

export const personDateBalanceQuerySchema = type({
  'personId?': type('string').configure({
    description: 'Filter balances to a specific person.',
    examples: ['per_018ef4a2'],
  }),
  'balanceDate?': type('string').configure({
    description: 'Filter balances to a specific calendar date (YYYY-MM-DD).',
    examples: ['2026-04-22'],
  }),
}).configure({ description: 'Query parameters for listing per-date person balances.' });

export type PersonDateBalanceQuery = typeof personDateBalanceQuerySchema.t;

export const createPersonDateBalanceSchema = type({
  personId: type('string').configure({
    description: 'Person whose balance is being recorded.',
    examples: ['per_018ef4a2'],
  }),
  balanceDate: type('string').configure({
    description: 'Calendar date the balance applies to, ISO 8601 (YYYY-MM-DD).',
    examples: ['2026-04-22'],
  }),
  valueMinutes: type('number').configure({
    description: 'Balance value expressed in minutes (positive = surplus, negative = deficit).',
    examples: [480],
  }),
  valueDays: type('number').configure({
    description: 'Balance value expressed in days (fractional allowed).',
    examples: [1],
  }),
}).configure({ description: 'Payload for recording a person balance on a given date.' });

export type CreatePersonDateBalance = typeof createPersonDateBalanceSchema.t;

export const updatePersonDateBalanceSchema = type({
  'personId?': type('string').configure({
    description: 'Updated person reference.',
    examples: ['per_018ef4a2'],
  }),
  'balanceDate?': type('string').configure({
    description: 'Updated calendar date (YYYY-MM-DD).',
    examples: ['2026-04-22'],
  }),
  'valueMinutes?': type('number').configure({
    description: 'Updated balance value in minutes.',
    examples: [480],
  }),
  'valueDays?': type('number').configure({
    description: 'Updated balance value in days.',
    examples: [1],
  }),
}).configure({ description: 'Partial update for a person-date balance. Fields omitted remain unchanged.' });

export type UpdatePersonDateBalance = typeof updatePersonDateBalanceSchema.t;

export interface PersonDateBalance {
  id: string;
  personId: string;
  balanceDate: string;
  valueMinutes: number;
  valueDays: number;
  createdAt: string;
  updatedAt: string;
}
